import BaseModel from '../core/BaseModel'
export default class ProjectModel extends BaseModel {
    constructor() {
        super({
            tableName: 'project', label: "Quản Lý Dự Án", display_key: 'name',name: "project",
        }, {
            stt: { 
              name: "stt", 
              label: "STT",
              class: 'center width_150 common',
              computed: (data, index) => {
                data.stt = index + 1;
              }
            },
            id: { 
              name: 'id', 
              type: "Uuid", 
              label: 'ID', 
              primaryKey: true,  
              display: false
            },
            name: {
                name: "name",
                type: "String",
                label: "Tên dự án",
                width: 20,
                filter: { type: "input", match: "contains" },
            },
            fee: {
                name: "fee",
                label: "Kinh phí (đ)",
                type: "Number",
                class: "right header-left",
                width: 10,
                filter: { type: "input", match: "contains" },
            },
            date_start: {
              name: "date_start",
              label: "Bắt đầu",
              type: "Date", 
              width: 9,
              filter: { type: 'DateRange', match: 'contains'},
            },
            date_end: {
              name: "date_end",
              label: "Kết thúc",
              type: "Date", 
              width: 9,
              filter: { type: 'DateRange', match: 'contains'},
            },
            department: {
              name: "department",
              label: "Bộ phận",
              type: "MultiSelect",
              width: 10,
              filter: {
                type: "SelectScroll",
                optionLabel: "name",
                optionKey: "id",
                match: "equals",
              },
            },
            status: {
              name: "status",
              label: "Trạng thái",
              type: "Selection",
              width: 10,
              options: [
                { value: "NEW", label: "Mới" },
                { value: "INPROCESS", label: "Đang thực hiện" },
                { value: "PENDING", label: "Tạm hoãn" },
                { value: "DONE", label: "Kết thúc" },
              ],
              filter: {
                type: "select",
                optionLabel: "label",
                optionKey: "value",
                match: "equals",
              },
            },
            evaluations: {
              name: "evaluations",
              label: "BPKS",
              type: "String",
              class: "center header-left",
              width: 5,
            },
            created_at : {
              name: 'created_at',
              type: "Datetime", 
              label: 'Ngày tạo',
              width: 9,
            },
            updated_at : {
              name: 'updated_at',
              type: "Datetime", 
              label: 'Ngày cập nhật',
              width: 9,
            },
        })
    }

}